import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CartComponent } from 'retail/app/orders/components/cart/cart.component';
import { CheckoutComponent } from 'retail/app/orders/components/checkout/checkout.component';
import { CustomerInfoComponent } from 'retail/app/orders/components/checkout/customer-info/customer-info.component';
import { CzechPostComponent } from 'retail/app/orders/components/checkout/czech-post/czech-post.component';
import { FinalComponent } from 'retail/app/orders/components/checkout/final/final.component';
import { OrderInfoComponent } from 'retail/app/orders/components/checkout/order-info/order-info.component';
import { ShipmentPaymentComponent } from 'retail/app/orders/components/checkout/shipment-payment/shipment-payment.component';
import { CheckoutService } from 'retail/app/orders/providers/checkout.service';
import { OrdersService } from 'retail/app/orders/providers/orders.service';
import { SharedUiModule } from 'shared-ui/shared-ui.module';

const routes: Routes = [
  { path: 'cart', component: CartComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'kosik', component: CartComponent },
  { path: 'objednavka', component: CheckoutComponent },
];

@NgModule({
  declarations: [
    CartComponent,
    CheckoutComponent,
    CzechPostComponent,
    FinalComponent,
    ShipmentPaymentComponent,
    CustomerInfoComponent,
    OrderInfoComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedUiModule,
    RouterModule.forChild(routes),
    LazyLoadImageModule,
    FormsModule,
  ],
  providers: [CheckoutService, OrdersService],
})
export class RetailOrdersModule {}
